import { Component, OnInit, ViewChildren, Input, Output, AfterViewInit, QueryList, EventEmitter } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { SidenavMenuStates } from 'src/app/core/enums/sidenav-menu-states.enum';
import { ToolbarService } from 'src/app/core/services/toolbar.service';
import { MenuItem } from 'src/portaljs/models/menu-item';

@Component({
  selector: 'fss-portal-menu-component',
  templateUrl: 'menu.component.html',
  styleUrls: ['./sidenav.component.scss'],
  standalone: false
})
export class NewMenuItemComponent implements OnInit, AfterViewInit {
  @Input() public title: string;
  @Input() public menu: MenuItem;
  @Input() public menuState: SidenavMenuStates;
  public SideNavMenuStates = SidenavMenuStates;
  @Output() public selectedEmit = new EventEmitter<string>();
  @ViewChildren(MatMenu) public matmenus: QueryList<MatMenu>;
  public menuItems: any[] = [];
  public initComplete: boolean = false;
  public submenus: any[] = [];

  constructor(private toolbarService: ToolbarService) {
  }

  public ngOnInit() {
    this.createSubmenus(this.menu.subMenuItems, this.menu.id.toString());
    this.reindex();
  }

  public getIcon(/** t: any */) {
    return '';
  }

  public isHighlighted(id: string) {
    return this.toolbarService.isHighlighted(id);
  }

  public ngAfterViewInit() {
    setTimeout(() => {
      this.initComplete = true;
    });
  }

  public onClick(value: any) {
    this.selectedEmit.emit(value);
  }

  public getMenu(index: number) {
    return index >= 0 && this.matmenus ? this.matmenus.find((x, i) => i == index) : null;
  }

  public reindex() {
    this.submenus.forEach(menu => {
      menu.forEach((x: any) => {
        if (x.test != -1)
          x.test = this.menuItems.indexOf(x.action);
      });
    });
  }

  public createSubmenus(menu: MenuItem[], prefix: string) {
    this.menuItems.push(prefix);
    this.submenus.push(
      menu.map((x: any, index: number) => {
        return ({
          name: x.name,
          id: x.id,
          icon: x.icon,
          count: x.count,
          accessKey: x.accessKey,
          action: x.test === null || x.subMenuItems === undefined ? x.fn : prefix + index,
          subMenu: x.test === null || x.subMenuItems === undefined ? -1 : 0
        });
      })
    );

    menu.forEach((x: any, index: number) => {
      if (x.subMenuItems) {
        this.createSubmenus(x.subMenuItems, prefix + index);
      }
    });
  }
}
